import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { callTrailerFacts } from "../subjects/stopEvent/callTrailerFacts";
import { stopEventRefs } from "../subjects/stopEvent/refs";

/**
 * The driver's call at a stop where a trailer was dropped.
 */
export const emptyCallV1 = tmsEventKind(
  { category: "call", kind: "emptyCall", version: 1 },
  {
    refs: stopEventRefs,
    facts: {
      stopName: z.string(),
      /** Absent on the forms that do not ask for it; the chip degrades to the stop name alone. */
      city: z.string().nullable(),
      /** The trailer the driver dropped. */
      trailerNumber: z.string().nullable(),
    },
  },
);

export const EmptyCallV1Schema = emptyCallV1.schema;
export const EmptyCallV1FactsSchema = emptyCallV1.facts;

export type EmptyCallV1 = z.infer<typeof EmptyCallV1Schema>;
export type EmptyCallV1Facts = z.infer<typeof EmptyCallV1FactsSchema>;

/**
 * Version 2: the same call, with both sides of the trailer exchange in place of the one dropped trailer.
 */
export const emptyCallV2 = tmsEventKind(
  { category: "call", kind: "emptyCall", version: 2 },
  { refs: stopEventRefs, facts: callTrailerFacts },
);

export const EmptyCallV2Schema = emptyCallV2.schema;
export const EmptyCallV2FactsSchema = emptyCallV2.facts;

export type EmptyCallV2 = z.infer<typeof EmptyCallV2Schema>;
export type EmptyCallV2Facts = z.infer<typeof EmptyCallV2FactsSchema>;

/** Every version of `emptyCall`, keyed by version. What `catalog.ts` places under `call`. */
export const emptyCall = { 1: emptyCallV1, 2: emptyCallV2 } as const;
